import { useCallback, useEffect, useMemo, useState } from "react"

import { useSelector } from "react-redux"

import { PROGRAM_META } from "../../constants/receipt-status-mapping"
import { selectPrograms } from "../../redux/receipt.slice"
import { ProgramCardsRow } from "./ProgramCardsRow"

const ProgramSelector = ({ selectedProgram, isDemo, getPrograms, onSelect }) => {
  const programs = useSelector(selectPrograms)
  const [loading, setLoading] = useState(false)

  const handleGetReceiptState = useCallback(async () => {
    try {
      setLoading(true)
      await getPrograms()
    } finally {
      setLoading(false)
    }
  }, [getPrograms])

  const cards = useMemo(
    () =>
      programs.map((p) => {
        const id = p.program.toLowerCase()
        const meta = PROGRAM_META?.[id]

        return {
          id,
          name: meta?.name,
          iconType: meta.iconType,
          value: p?.lookup_count,
          // The API sends the aggregated status for "All" too (CHA1-2775), but that card shows
          // no status chip; only the per-program cards do.
          status: id === "all" ? null : p?.status
        }
      }),
    [programs]
  )

  useEffect(() => {
    void handleGetReceiptState()
  }, [handleGetReceiptState, isDemo])

  return (
    <ProgramCardsRow
      cards={cards}
      loading={loading}
      selectedProgram={selectedProgram}
      onSelect={onSelect}
    />
  )
}

export default ProgramSelector
